export enum Language {
  En = 'en',
  Ua = 'ua'
}

export const languageList = [Language.En, Language.Ua];

export function checkLanguage(lng: string) {
  const sliceLng = (lng || '').slice(0, 2).toLowerCase();
  if (sliceLng === 'uk' || sliceLng === 'ru') return Language.Ua;
  return languageList.includes(sliceLng as Language) ? (sliceLng as Language) : Language.En;
}

// NEW: map between route <-> i18next codes
export function i18nFromRoute(routeLang: Language) {
  return routeLang === Language.Ua ? 'uk' : 'en';
}
export function routeFromI18n(i18nLng: string): Language {
  const s = (i18nLng || '').slice(0,2).toLowerCase();
  return (s === 'uk' || s === 'ru') ? Language.Ua : Language.En;
}
